export default __webpack_public_path__ + "static/media/about_icon5hover.8483eb40.svg";